(() => {
  let giftsChanging = false;
  let refreshRequested = false;
  let refreshing = false;

  const refreshCart = async () => {
    const cartHelper = window.Alpine?.store('xCartHelper');
    if (refreshing || !refreshRequested || !cartHelper) return;

    refreshing = true;
    try {
      while (refreshRequested) {
        // Let the theme finish rendering its add/change response first.
        await cartHelper.waitForCartUpdate();
        refreshRequested = false;
        window.updatingCart = true;
        try {
          await cartHelper.reRenderSections();
          const count = document.querySelector('#cart-icon-bubble span');
          if (count) cartHelper.currentItemCount = parseInt(count.textContent, 10) || 0;
        } finally {
          window.updatingCart = false;
        }
        document.dispatchEvent(new CustomEvent('eurus:cart:items-changed'));
      }
    } catch (error) {
      console.error('AutoCart: unable to refresh the cart', error);
    } finally {
      refreshing = false;
    }
  };

  // AutoCart can debounce a changed result into a subsequent "noop" result.
  // Remember the mutation until its completion event arrives.
  document.addEventListener('autocart:before', (event) => {
    if (event.detail?.changes?.length) giftsChanging = true;
  });

  document.addEventListener('autocart:updated', (event) => {
    if (!giftsChanging && !event.detail?.changes?.length) return;
    giftsChanging = false;
    refreshRequested = true;
    void refreshCart();
  });

  document.addEventListener('autocart:error', () => {
    // An app error may follow a partially completed gift update.
    if (!giftsChanging) return;
    giftsChanging = false;
    refreshRequested = true;
    void refreshCart();
  });

  document.addEventListener('alpine:initialized', () => void refreshCart());
})();
